import { getPhotoAndCaptions } from "api/getPhotoAndCaptions";
import { Photo } from "api/types/photo";
import { SiteSurveyConfiguration } from "api/types/siteSurveyConfiguration";
import { Photos } from "../photos";

export function SitePhots({
  config,
  photos,
}: {
  config: SiteSurveyConfiguration;
  photos: Photo[];
}) {
  const pairs = getPhotoAndCaptions(config.photoTypes, photos);

  return <Photos title="Site Photos" photoAndCaptionPairs={pairs} />;
}
